import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';
import { withRouter } from 'react-router-dom';

import { useCredit } from 'api';
import { fetchUserCredit } from 'actions/credit';
import { findPurchase } from 'actions/purchases';
import { getPageCount, getUserCredits } from 'reducers';
import CreditList from './CreditList/CreditList';
import FormError from './FormError';
import Pagination from './Pagination/Pagination';
import { scrollToBlock } from 'helpers/scrolls';

class ApplyCredit extends Component {
  constructor(props) {
    super(props);

    this.pushCredit = this.pushCredit.bind(this);
    this.applyCredits = this.applyCredits.bind(this);
    this.getCredits = this.getCredits.bind(this);

    this.state = {
      showList: false,
      isSuccess: false,
      creditList: [],
      error: null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.creditsPage !== this.props.creditsPage) {
      this.getCredits(this.props.creditsPage);
      scrollToBlock('#credits-section');
    }
  }

  showCredits = () => {
    const { location, history, creditsPage } = this.props;
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    const searchParams = new URLSearchParams({
      ...query,
      creditsPage: 1,
    });

    history.push({
      search: `?${searchParams.toString()}`,
    });
    if (creditsPage === '1') {
      this.getCredits(creditsPage);
    }
  };

  getCredits = async (page = '1') => {
    const {
      fetchUserCredit,
      purchase: { user_profile },
    } = this.props;

    try {
      await fetchUserCredit(user_profile, page);
      this.setState({ showList: true });
    } catch (error) {
      const errorMsg = (error.response && error.response.data) || {
        message: `Error occurred when you try to get credit's list.`,
      };
      this.setState({ error: errorMsg });
    }
  };

  getPage = (page) => {
    const { location, purchase } = this.props;
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    const searchParams = new URLSearchParams({
      ...query,
      creditsPage: page,
    });

    return `/purchases/${purchase?.id}/view?${searchParams.toString()}`;
  };

  pushCredit(creditId, isChecked) {
    const { creditList } = this.state;

    if (isChecked) {
      this.setState({ creditList: [creditId, ...creditList] });
    } else {
      this.setState({
        creditList: [...creditList.filter((id) => id !== creditId)],
      });
    }
  }

  async applyCredits() {
    const {
      purchase: { id: purchaseId },
      findPurchase,
    } = this.props;
    const { creditList } = this.state;
    const requestsArray = creditList.map((id) =>
      useCredit({ purchaseId, creditId: id }),
    );

    try {
      await Promise.all(requestsArray);
      await findPurchase(purchaseId);
      this.setState({ isSuccess: true, showList: false });
    } catch (error) {
      const errorMsg = (error.response && error.response.data) || {
        message: 'Error occurred when you try to apply credit.',
      };
      this.setState({ error: errorMsg });
    }
  }

  render() {
    const { credits, pageCount, creditsPage } = this.props;
    const { error, isSuccess, showList, creditList } = this.state;

    return (
      <article id="credits-section">
        <h4>Credit List</h4>
        {isSuccess && (
          <div className="text-success">
            Credit has been successfully applied.
          </div>
        )}
        {error && <FormError error={error} />}
        <button
          className="btn btn-default"
          title="Press on the button to get credits list"
          onClick={() => this.showCredits()}
        >
          Use Credit
        </button>
        {showList && (
          <React.Fragment>
            <CreditList
              credits={credits}
              pushCredit={this.pushCredit}
              isCreditsForAppling={true}
            />
            <Pagination
              count={pageCount}
              current={creditsPage}
              url={this.getPage}
            />
          </React.Fragment>
        )}
        <br />
        {showList && (
          <button
            type="button"
            className="btn btn-primary"
            disabled={!creditList.length}
            onClick={this.applyCredits}
          >
            Apply credits
          </button>
        )}
        <br />
      </article>
    );
  }
}

const mapDispatchToProps = {
  fetchUserCredit,
  findPurchase,
};

const mapStateToProps = (state, { location }) => {
  const { creditsPage = '1' } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  return {
    credits: getUserCredits(state, creditsPage),
    pageCount: getPageCount(state, 'credit', `fetchByUser`, creditsPage),
    creditsPage,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ApplyCredit),
);
